import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';

export function accountCRAReducer(state = initialstate.accountValidationCount, action) {
	switch (action.type) {
		case types.GET_ACCOUNT_VALIDATION_COUNT:
			if (action.payload.assertionWithIncompleteCRA) {
				if (!_.isEmpty(action.response?.data)) {
					let assertionCount = 0;
					action.response.data?.forEach((account) => {
						if (_.isEmpty(account.assertions)) {
							assertionCount++;
						} else {
							account.assertions?.forEach((assertion) => {
								if (_.isEmpty(assertion.craValue)) {
									assertionCount++;
								}
							});
						}
					});
					return assertionCount;
				} else {
					return 0;
				}
			} else {
				if (!_.isEmpty(action.response) && !_.isUndefined(action.response.totalEntityCount)) {
					return action.response.totalEntityCount;
				} else {
					return state;
				}
			}
		default:
			return state;
	}
}
